import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createClothStockEntry = createAsyncThunk('createClothStockEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertClothStock`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateClothStockEntry = createAsyncThunk('updateClothStockEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateClothStock`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

// insert lump details
export const insertClothStkLump = createAsyncThunk('insertClothStkLump', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertClothStkLumps`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchClothStockData = createAsyncThunk('fetchClothStockData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getClothStockList`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSingleClothStock = createAsyncThunk('fetchSingleClothStock', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getClothStockList&clstkId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleClothStock = createAsyncThunk('deleteSingleClothStock', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteClothStock&clstkId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchCStkLamplist = createAsyncThunk('fetchCStkLamplist', async (id) => {
    const { clothId, idx } = id;
    try {
        const response = await axios.get(`${baseUrl}?apicall=getCstkLumpDetails&clothid=${clothId}&idx=${idx}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchclothstklump = createAsyncThunk('fetchclothstklump', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getClothStockListwithlump&bId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const clothstkSlice = createSlice({
    name: 'ClothStockData',
    initialState: {
        isLoading: false,
        clothStock: null,
        deleteClothStock: null,
        singleClothStock: null,
        lumplist: null,
        onlylump: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchClothStockData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchClothStockData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.clothStock = action.payload;
        });
        builder.addCase(fetchClothStockData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleClothStock.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleClothStock.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteClothStock = action.payload;
        });
        builder.addCase(deleteSingleClothStock.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleClothStock.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleClothStock.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleClothStock = action.payload;
        });
        builder.addCase(fetchSingleClothStock.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchCStkLamplist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCStkLamplist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.lumplist = action.payload;
        });
        builder.addCase(fetchCStkLamplist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchclothstklump.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchclothstklump.fulfilled, (state, action) => {
            state.isLoading = false;
            state.onlylump = action.payload;
        });
        builder.addCase(fetchclothstklump.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default clothstkSlice.reducer;
